import React from 'react';
import { Clock, ShieldX } from 'lucide-react';

const PendingApproval = ({ user, onLogout }) => {
  return (
    <div className="min-h-screen bg-[#0f1724] flex items-center justify-center p-4" data-testid="pending-approval">
      <div className="bg-[#1a2332] border border-[#2a3444] rounded-2xl p-8 max-w-md w-full text-center">
        {user?.approval_status === 'denied' ? (
          <>
            <ShieldX className="w-16 h-16 mx-auto mb-4 text-red-400" />
            <h1 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
              Acceso Denegado
            </h1>
            <p className="text-gray-400 mb-6">
              Tu solicitud de acceso ha sido denegada. Si crees que es un error, contacta al administrador.
            </p>
          </>
        ) : (
          <>
            <Clock className="w-16 h-16 mx-auto mb-4 text-[#D4AF37] animate-pulse" />
            <h1 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
              Solicitud en Revisión
            </h1>
            <p className="text-gray-400 mb-6">
              Tu cuenta ha sido creada exitosamente. Un administrador revisará tu solicitud y te asignará acceso pronto.
            </p>
            <div className="bg-[#141b2d] rounded-lg p-4 mb-6">
              <div className="flex items-center gap-3">
                {user?.picture && <img src={user.picture} alt="" className="w-10 h-10 rounded-full" />}
                <div className="text-left">
                  <p className="text-white font-medium">{user?.name}</p>
                  <p className="text-sm text-gray-500">{user?.email}</p>
                </div>
              </div>
            </div>
          </>
        )}
        <button onClick={onLogout}
          className="w-full bg-[#2a3444] text-gray-300 py-3 rounded-lg hover:bg-[#3a4454] transition-colors"
          data-testid="logout-pending-btn">
          Cerrar sesión
        </button>
      </div>
    </div>
  );
};

export default PendingApproval;
